import { makeHttpRequest } from "@/shared";

// Значения пользовательских полей приёмки: пустой объект не отправляем,
// иначе сохранение до их загрузки затрёт уже введённые данные.
const mapCustomFields = (customFields) => {
    if (!customFields || Object.keys(customFields).length === 0) return {};

    return { custom_fields: customFields };
};

// Карточка устройства заказа (device-first приёмка).
export const saveRepairDevice = async (repairId, device) => {
    const response = (
        await makeHttpRequest({
            url: `/repair/${repairId}/device`,
            method: "PUT",
            data: {
                title: device.title || null,
                brand: device.brand || null,
                model: device.model || null,
                serial: device.serial || null,
                imei: device.imei || null,
                password: device.password || null,
                defect: device.defect || null,
                appearance: device.appearance || null,
                equipment: device.equipment || null,
                approximate_price: device.approximatePrice || null,
                was_under_repair: device.wasUnderRepair || null,
                master_notes: device.masterNotes || null,
                biometric_security_works: Boolean(
                    device.biometricSecurityWorks
                ),
                proximity_sensor_works: Boolean(device.proximitySensorWorks),
                moisture_sensor: Boolean(device.moistureSensor),
                ...mapCustomFields(device.customFields),
            },
        })
    ).data;

    return response?.data ?? null;
};
